import { HtmlTag } from "svelte/internal";

export const R1 = [
    "Keine Erfahrung",
    "Anfänger",
    "Grunderfahrung",
    "Erfahrener",
    "Experter"
];

export const R2 = [
    "Keine Erfahrung (DEEPSEA, COMAP, DEIF, ETC.)",
    "Anfänger (DEEPSEA, COMAP, DEIF, ETC.)",
    "Grunderfahrung (DEEPSEA, COMAP, DEIF, ETC.)",
    "Erfahrener (DEEPSEA, COMAP, DEIF, ETC.)",
    "Experter (DEEPSEA, COMAP, DEIF, ETC.)"
];

export const R3 = [
    "Keine Erfahrung (BASLER, UNITROL, ETC.)",
    "Anfänger (BASLER, UNITROL, ETC.)",
    "Grunderfahrung (BASLER, UNITROL, ETC.)",
    "Erfahrener (BASLER, UNITROL, ETC.)",
    "Experter (BASLER, UNITROL, ETC.)"
];

export const R4 = [
    "Ja",
    "Nein",
    "Externer"
];

export const R5 = [
    "Bis zu 200 kva",
    "Bis zu 500 kva",
    "Bis zu 1000 kva",
    "Bis zu 1500 kva",
    "Bis zu 2000 kva",
    "Bis zu 2500 kva",
    "Bis zu 3000 kva",
    "Keine Begrenzung"
];

export const R6 = [
    "Kein Service vor Ort",
    "Bis zu 500 km",
    "Bis zu 1000 km",
    "über 1000 km (keine Begrenzung)"
];

export const R7 = [
    "Keine",
    "Ja von 1 bis 5",
    "Ja von 6 bis 10",
    "Ja mehr als 10"
];

export const R8 = [
    "Ja",
    "Nein"
];

export const R9 = [
    "Ja mit Laser",
    "Ja mit Messuhr",
    "Ja mit andere Messgerät",
    "Nein"
];
export const R10 = [
    "Ja Service bestätigt",
    "Nicht verfügbar"
];

export const R11 = [
    "Genehmigt",
    "Nicht genehmigt"
];

export const R12 = [
    "Null",
    "Schwach",
    "Grundlegend",
    "Gut",
    "Hervorragend"
];

export const R13 = [
    "Service",
    "Meccalte"
];

export const RArea = [
    "Europa - Italien",
    "Europa - Spanien",
    "Europa - Großbritannien / EIRE",
    "Europa - Deutschland",
    "Europa - Frankreich",
    "Europa - Russland",
    "Europa - Andere Länder",
    "Afrika",
    "Nordamerika",
    "Zentralamerika",
    "Südamerika",
    "Mittlerer Osten",
    "Fernost - Indien",
    "Fernost"
]



export const DENotes = [
    "Die Schaltfläche rechts füllt das Feld automatisch anhand der oben aufgeführten Informationen. Wenn diese Informationen nicht erkannt werden, geben Sie die durch Komma getrennten Koordinaten, Breiten- und Längengrade manuell ein <br> (Beispiel  : 45.6515661 , 11.8564252, dann Breitengrad, dann ein Leerzeichen, dann ein Komma, dann ein Leerzeichen und schließlich den Längengrad).",
    "Techniker, Ingenieure für Untersuchung vor Ort",
    "Füllen Sie für jede weitere Einrichtung / Zweigniederlassung einen zusätzlichen SPQ-Fragebogen aus",
    "Ungefähre Anzahl von Reparaturen im Werkstatt und Untersuchungen für Mecc Alte vor Ort",
    "Die Anzahl der Reparaturen im Werkstatt und Untersuchungen vor Ort für Mecc Alte die in den letzten 12 Monaten, geben Sie den Zeitraum an",
    "Standardstundensatz für Werkstatt-Arbeit",
    "Standardstundensatz für Aktivitäten vor Ort",
    "Prüfungs / Besuchsdatum; Besucher von Meccalte angeben",
    "Kommentieren Sie mögliche Wettbewerbe mit anderen Generatorherstellern",
    "Kommentieren Sie mögliche Wettbewerbe mit anderen Aggreagatherstellern",
    "Wählen Sie eine Ebene für umfassende Berichterstattung und eine gute Kommunikationshaltung",
    "Wählen Sie den Genehmigungsstatus und den autorisierten Status"
];